import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-valores-totais',
  templateUrl: './valores-totais.component.html',
  styleUrls: ['./valores-totais.component.css']
})
export class ValoresTotaisComponent implements OnInit, OnChanges {
  @Input() totalBruto: number = 0;
  @Input() totalLiquido: number = 0;
  @Input() descontosItens: number = 0;
  @Input() desconto: number = 0;
  @Input() descontoAdicional: number = 0;
  @Input() descontoUnitario: number = 0;

  constructor() { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

}
